/**
 * VueToastsPlugin
 * Vue plugin for simplifying Buefy toast messages
 * Author: Paul marti
 * Email: pablo@intermediatica.net
 *
 * Note:
 * This specific version requires Buefy plugin installed BEFORE.
 */

import { ToastProgrammatic as Toast } from 'buefy';

let VueToastPlugin = {};

VueToastPlugin.install = (Vue, options) => {
  Vue.prototype.$toast = (type, msg) => {
    let toast_type;

    switch (type) {
      case 'info':
        toast_type = 'is-info';
        break;

      case 'success':
        toast_type = 'is-success';
        break;

      case 'warning':
        toast_type = 'is-warning';
        break;

      case 'danger':
      case 'error':
        toast_type = 'is-danger';
        break;

      case 'dark':
        toast_type = 'is-dark';
        break;

      case 'white':
        toast_type = 'is-white';
        break;

      default:
        toast_type = 'is-dark';
        break;
    }

    Toast.open({
      duration: 5000,
      message: msg,
      type: toast_type,
      queue: false,
      position: 'is-top',
    });
  };
};

export default VueToastPlugin;
